import styled from 'styled-components'
import Text from '../atoms/Text';
import CancelIcon from '@mui/icons-material/Cancel';
import BaseInput from '../atoms/BaseInput';
import MicRoundedIcon from '@mui/icons-material/MicRounded';

const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 50px;
`;
const LabelWrapper = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
`
const RequiredCircle = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.status.error};
`
const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 50px;
`
const ButtonWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  display: flex;
  gap: 8px;
`
const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
`;
const ClearIcon = styled(CancelIcon)`
  color: ${(props) => props.theme.colors.text.assistive};
`
const MicIcon = styled(MicRoundedIcon)`
  color: ${(props) => props.theme.colors.text.alternative};
`
const StyledBaseInput = styled(BaseInput)`
  padding-right: 80px;
`
const VoiceInput = ({label, placeholder, value, onChange, onMicClick, onClear, required=false, ...props}) => {
  const handleClear = (e) => {
    e.preventDefault();
    // onChange({ target: { value: "" } });
    onClear?.();
  };
  
  return (
    <Container>
      <label>
        <LabelWrapper>
          <Text as="label" variant="body2" weight="medium">{label}</Text>
          {required && <RequiredCircle aria-label="필수 입력 항목"/>}
        </LabelWrapper>
        <InputWrapper>
          <StyledBaseInput
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            {...props}/>
          <ButtonWrapper>
            {value && (
              <IconButton onClick={handleClear}>
                <ClearIcon />
              </IconButton>
            )}
            <IconButton onClick={onMicClick}>
              <MicIcon/>
            </IconButton>
          </ButtonWrapper>
        </InputWrapper>
      </label>
    </Container>
  )
}

export default VoiceInput
